import React, { useState } from "react";
import { validateWorkflowJSON } from "../../utils/workflowSchema";
import { validateConnections } from "../../utils/workflowGraph";
import { saveWorkflow } from "../../utils/executionStorage";

export default function WorkflowUploader({ onUploaded }) {
  const [error, setError] = useState(null);

  const handleFileChange = async (e) => {
    setError(null);
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    if (!file.name.toLowerCase().endsWith(".json")) {
      setError("Please select a .json file");
      return;
    }
    try {
      const text = await file.text();
      const parsed = JSON.parse(text);
      const valid = validateWorkflowJSON(parsed);
      if (!valid.ok) {
        setError(valid.error);
        return;
      }
      const connErrs = validateConnections(parsed);
      if (connErrs.length) {
        setError(connErrs.join("; "));
        return;
      }
      saveWorkflow(parsed);
      onUploaded(parsed);
    } catch (err) {
      setError("Failed to read or parse JSON file");
    }
  };

  return (
    <div className="workflow-uploader">
      <h2>Upload Workflow</h2>
      {error && <div className="error-message">{error}</div>}
      <input type="file" accept=".json" onChange={handleFileChange} />
    </div>
  );
}
